<script lang="ts">
    import MainLayout from "../#common/layout/Layout.svelte"
</script>

<svelte:head>
    <title>Notifications</title>
</svelte:head>

<MainLayout>
    <svelte:fragment slot="content">
        <div class="cabinet-wrapper">
            <div class="page-title">Notifications</div>
            Coming soon...
        </div>
    </svelte:fragment>
</MainLayout>
